import { render } from "./DeviceDistribution.vue?vue&type=template&id=1972a3fe&scoped=true"
import script from "./DeviceDistribution.vue?vue&type=script&lang=js"
export * from "./DeviceDistribution.vue?vue&type=script&lang=js"

import "./DeviceDistribution.vue?vue&type=style&index=0&id=1972a3fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1972a3fe"]])

export default __exports__